var map = {
	"./": 74,
	"./App": 175,
	"./App.js": 175,
	"./assets/fonts/Baskerville.ttf": 499,
	"./assets/fonts/Baskerville.woff2": 500,
	"./assets/fonts/Roboto-Regular.woff": 501,
	"./assets/fonts/Roboto-Regular.woff2": 502,
	"./assets/images/_global/bookappointment.svg": 503,
	"./assets/images/_global/icons/Ledmac_Wechat_Qr_Code_Banner.jpeg": 263,
	"./assets/images/_global/icons/arrow_left.svg": 267,
	"./assets/images/_global/icons/arrow_left@2x.png": 504,
	"./assets/images/_global/icons/arrow_right.svg": 268,
	"./assets/images/_global/icons/arrow_right@2x.png": 505,
	"./assets/images/_global/icons/calendar.png": 506,
	"./assets/images/_global/icons/calendar.svg": 231,
	"./assets/images/_global/icons/carousel-arrow-left.png": 507,
	"./assets/images/_global/icons/carousel-arrow-left.svg": 508,
	"./assets/images/_global/icons/carousel-arrow-right.png": 509,
	"./assets/images/_global/icons/carousel-arrow-right.svg": 510,
	"./assets/images/_global/icons/checkmark.svg": 511,
	"./assets/images/_global/icons/close.svg": 68,
	"./assets/images/_global/icons/icon-facebook.png": 258,
	"./assets/images/_global/icons/icon-instagram.png": 261,
	"./assets/images/_global/icons/icon-linkedin.png": 262,
	"./assets/images/_global/icons/icon-twitter.png": 259,
	"./assets/images/_global/icons/icon-weixin.png": 257,
	"./assets/images/_global/icons/icon-youtube.png": 260,
	"./assets/images/_global/icons/select-down.svg": 269,
	"./assets/images/_global/icons/wechat-close-icon.png": 264,
	"./assets/images/_global/logos/ledmac-logo.svg": 224,
	"./assets/images/_global/logos/logo_full_white.svg": 159,
	"./assets/images/_global/logos/logo_full_white@2x.png": 512,
	"./assets/images/_global/map@2x.png": 513,
	"./assets/images/_global/map@3x.png": 256,
	"./assets/images/_global/pattern_left.svg": 270,
	"./assets/images/_global/pattern_right.svg": 271,
	"./assets/images/amenities/call out_poi.svg": 514,
	"./assets/images/amenities/call_out.png": 272,
	"./assets/images/amenities/gather/amenity_kitchen.jpg": 273,
	"./assets/images/amenities/gather/amenity_lobby_fireplace.jpg": 274,
	"./assets/images/amenities/gather/amenity_ping-pong.jpg": 275,
	"./assets/images/amenities/hero.jpg": 276,
	"./assets/images/amenities/level_1_birdseye.png": 277,
	"./assets/images/amenities/level_7_birdseye.png": 278,
	"./assets/images/amenities/lightbox/amenity_exterior.jpg": 279,
	"./assets/images/amenities/lightbox/amenity_kitchen.jpg": 280,
	"./assets/images/amenities/lightbox/amenity_lobby-concierge.jpg": 281,
	"./assets/images/amenities/lightbox/amenity_lobby_fireplace.jpg": 282,
	"./assets/images/amenities/lightbox/amenity_ping-pong.jpg": 283,
	"./assets/images/amenities/lightbox/amenity_rooftop.jpg": 284,
	"./assets/images/amenities/lightbox/close_icon.svg": 515,
	"./assets/images/amenities/sun/amenity_exterior.jpg": 285,
	"./assets/images/amenities/sun/amenity_rooftop.jpg": 286,
	"./assets/images/developer/Arcadis_Logo.png": 287,
	"./assets/images/developer/ledmac_tagline.svg": 288,
	"./assets/images/developer/logo_ibi.png": 289,
	"./assets/images/developer/logo_pwl.png": 290,
	"./assets/images/developer/logo_themill.png": 291,
	"./assets/images/developer/projects/01_escala-burnaby.jpg": 41,
	"./assets/images/developer/projects/02_aviara-burnaby.jpg": 42,
	"./assets/images/developer/projects/03_reflections-burnaby.jpg": 43,
	"./assets/images/developer/projects/04_waterscapes-kelowna.jpg": 44,
	"./assets/images/developer/projects/05_highpoint-coquitlam.jpg": 45,
	"./assets/images/developer/projects/06_icon-burnaby.jpg": 46,
	"./assets/images/developer/projects/07_sydney-coquitlam.jpg": 47,
	"./assets/images/developer/projects/08_azure-burnaby.jpg": 48,
	"./assets/images/developer/projects/09_northgate_village-burnaby.jpg": 49,
	"./assets/images/developer/projects/10_perspectives-burnaby.jpg": 50,
	"./assets/images/developer/projects/11_saltaire-white_rock.jpg": 51,
	"./assets/images/developer/projects/12_dominion-new_westminster.jpg": 52,
	"./assets/images/floorplans/accordion_down.svg": 516,
	"./assets/images/floorplans/accordion_down@2x.png": 517,
	"./assets/images/floorplans/accordion_up.svg": 518,
	"./assets/images/floorplans/accordion_up@2x.png": 519,
	"./assets/images/floorplans/north.svg": 520,
	"./assets/images/floorplans/plans/a.png": 292,
	"./assets/images/floorplans/plans/a1.png": 293,
	"./assets/images/floorplans/plans/a_805.png": 294,
	"./assets/images/floorplans/plans/b.png": 295,
	"./assets/images/floorplans/plans/b1.png": 296,
	"./assets/images/floorplans/plans/b2.png": 297,
	"./assets/images/floorplans/plans/c.png": 298,
	"./assets/images/floorplans/plans/c1.png": 299,
	"./assets/images/floorplans/plans/ph1.png": 300,
	"./assets/images/floorplans/plans/ph2.png": 301,
	"./assets/images/floorplans/plans/ph3.png": 302,
	"./assets/images/floorplans/plans/th1.png": 303,
	"./assets/images/floorplans/plans/th2.png": 304,
	"./assets/images/floorplans/plates/a.png": 305,
	"./assets/images/floorplans/plates/a1.png": 306,
	"./assets/images/floorplans/plates/a_805.png": 307,
	"./assets/images/floorplans/plates/b.png": 308,
	"./assets/images/floorplans/plates/b1.png": 309,
	"./assets/images/floorplans/plates/b2.png": 310,
	"./assets/images/floorplans/plates/c.png": 311,
	"./assets/images/floorplans/plates/c1.png": 312,
	"./assets/images/floorplans/plates/ph1.png": 313,
	"./assets/images/floorplans/plates/ph2.png": 314,
	"./assets/images/floorplans/plates/ph3.png": 315,
	"./assets/images/floorplans/plates/th1.png": 316,
	"./assets/images/floorplans/plates/th2.png": 317,
	"./assets/images/floorplans/views/Riviera_Level_05.jpg": 318,
	"./assets/images/floorplans/views/Riviera_Level_08.jpg": 319,
	"./assets/images/floorplans/views/Riviera_Level_11.jpg": 320,
	"./assets/images/floorplans/views/Riviera_Level_14.jpg": 321,
	"./assets/images/floorplans/views/Riviera_Level_17.jpg": 322,
	"./assets/images/floorplans/views/Riviera_Level_20.jpg": 323,
	"./assets/images/floorplans/views/Riviera_Level_23.jpg": 324,
	"./assets/images/floorplans/views/Riviera_Level_26.jpg": 325,
	"./assets/images/floorplans/views/Riviera_Level_29.jpg": 326,
	"./assets/images/floorplans/views/Riviera_Level_32.jpg": 327,
	"./assets/images/floorplans/views/Riviera_Level_35.jpg": 225,
	"./assets/images/floorplans/views/View_Study_Reference_Mar31-2022.pdf": 521,
	"./assets/images/gallery/building/lightbox/amenity_kitchen.jpg": 145,
	"./assets/images/gallery/building/lightbox/amenity_ping-pong.jpg": 143,
	"./assets/images/gallery/building/lightbox/entrance.jpg": 135,
	"./assets/images/gallery/building/lightbox/exterior.jpg": 133,
	"./assets/images/gallery/building/lightbox/lobby-concierge.jpg": 139,
	"./assets/images/gallery/building/lightbox/lobby-fireplace.jpg": 141,
	"./assets/images/gallery/building/lightbox/rooftop.jpg": 147,
	"./assets/images/gallery/building/lightbox/terrace.jpg": 137,
	"./assets/images/gallery/building/thumbs/amenity_kitchen.jpg": 146,
	"./assets/images/gallery/building/thumbs/amenity_ping-pong.jpg": 144,
	"./assets/images/gallery/building/thumbs/entrance.jpg": 136,
	"./assets/images/gallery/building/thumbs/exterior.jpg": 134,
	"./assets/images/gallery/building/thumbs/lobby-concierge.jpg": 140,
	"./assets/images/gallery/building/thumbs/lobby-fireplace.jpg": 142,
	"./assets/images/gallery/building/thumbs/rooftop.jpg": 148,
	"./assets/images/gallery/building/thumbs/terrace.jpg": 138,
	"./assets/images/gallery/hero.png": 328,
	"./assets/images/gallery/interiors/lightbox/display-suite-01.jpg": 87,
	"./assets/images/gallery/interiors/lightbox/display-suite-02.png": 85,
	"./assets/images/gallery/interiors/lightbox/display-suite-03.png": 103,
	"./assets/images/gallery/interiors/lightbox/display-suite-04.jpg": 89,
	"./assets/images/gallery/interiors/lightbox/display-suite-05.jpg": 79,
	"./assets/images/gallery/interiors/lightbox/display-suite-06.png": 107,
	"./assets/images/gallery/interiors/lightbox/display-suite-07.png": 109,
	"./assets/images/gallery/interiors/lightbox/display-suite-08.jpg": 105,
	"./assets/images/gallery/interiors/lightbox/display-suite-09.jpg": 111,
	"./assets/images/gallery/interiors/lightbox/display-suite-10.jpg": 113,
	"./assets/images/gallery/interiors/lightbox/display-suite-11.jpg": 81,
	"./assets/images/gallery/interiors/lightbox/display-suite-12.jpg": 77,
	"./assets/images/gallery/interiors/lightbox/display-suite-13.jpg": 83,
	"./assets/images/gallery/interiors/lightbox/display-suite-14.jpg": 99,
	"./assets/images/gallery/interiors/lightbox/display-suite-15.jpg": 95,
	"./assets/images/gallery/interiors/lightbox/display-suite-16.jpg": 91,
	"./assets/images/gallery/interiors/lightbox/display-suite-17.jpg": 97,
	"./assets/images/gallery/interiors/lightbox/display-suite-18.png": 93,
	"./assets/images/gallery/interiors/lightbox/display-suite-19.jpg": 101,
	"./assets/images/gallery/interiors/lightbox/ensuite_dark.jpg": 522,
	"./assets/images/gallery/interiors/lightbox/ensuite_light.jpg": 523,
	"./assets/images/gallery/interiors/lightbox/living-space_dark.jpg": 524,
	"./assets/images/gallery/interiors/lightbox/living-space_light.jpg": 525,
	"./assets/images/gallery/interiors/thumbs/display-suite-01.jpg": 88,
	"./assets/images/gallery/interiors/thumbs/display-suite-02.jpg": 86,
	"./assets/images/gallery/interiors/thumbs/display-suite-03.jpg": 104,
	"./assets/images/gallery/interiors/thumbs/display-suite-04.jpg": 90,
	"./assets/images/gallery/interiors/thumbs/display-suite-05.jpg": 80,
	"./assets/images/gallery/interiors/thumbs/display-suite-06.jpg": 108,
	"./assets/images/gallery/interiors/thumbs/display-suite-07.jpg": 110,
	"./assets/images/gallery/interiors/thumbs/display-suite-08.jpg": 106,
	"./assets/images/gallery/interiors/thumbs/display-suite-09.jpg": 112,
	"./assets/images/gallery/interiors/thumbs/display-suite-10.jpg": 114,
	"./assets/images/gallery/interiors/thumbs/display-suite-11.jpg": 82,
	"./assets/images/gallery/interiors/thumbs/display-suite-12.jpg": 78,
	"./assets/images/gallery/interiors/thumbs/display-suite-13.jpg": 84,
	"./assets/images/gallery/interiors/thumbs/display-suite-14.jpg": 100,
	"./assets/images/gallery/interiors/thumbs/display-suite-15.jpg": 96,
	"./assets/images/gallery/interiors/thumbs/display-suite-16.jpg": 92,
	"./assets/images/gallery/interiors/thumbs/display-suite-17.jpg": 98,
	"./assets/images/gallery/interiors/thumbs/display-suite-18.jpg": 94,
	"./assets/images/gallery/interiors/thumbs/display-suite-19.jpg": 102,
	"./assets/images/gallery/interiors/thumbs/ensuite_dark.jpg": 526,
	"./assets/images/gallery/interiors/thumbs/ensuite_light.jpg": 527,
	"./assets/images/gallery/interiors/thumbs/living-space_dark.jpg": 528,
	"./assets/images/gallery/interiors/thumbs/living-space_light.jpg": 529,
	"./assets/images/gallery/neighbourhood/gallery_01.jpg": 115,
	"./assets/images/gallery/neighbourhood/gallery_01_thumb.jpg": 116,
	"./assets/images/gallery/neighbourhood/gallery_02.jpg": 117,
	"./assets/images/gallery/neighbourhood/gallery_02_thumb.jpg": 118,
	"./assets/images/gallery/neighbourhood/gallery_03.jpg": 119,
	"./assets/images/gallery/neighbourhood/gallery_03_thumb.jpg": 120,
	"./assets/images/gallery/neighbourhood/gallery_04.jpg": 121,
	"./assets/images/gallery/neighbourhood/gallery_04_thumb.jpg": 122,
	"./assets/images/gallery/neighbourhood/gallery_05.jpg": 123,
	"./assets/images/gallery/neighbourhood/gallery_05_thumb.jpg": 124,
	"./assets/images/gallery/neighbourhood/gallery_06.jpg": 125,
	"./assets/images/gallery/neighbourhood/gallery_06_thumb.jpg": 126,
	"./assets/images/gallery/neighbourhood/gallery_07.jpg": 127,
	"./assets/images/gallery/neighbourhood/gallery_07_thumb.jpg": 128,
	"./assets/images/gallery/neighbourhood/gallery_08.jpg": 129,
	"./assets/images/gallery/neighbourhood/gallery_08_thumb.jpg": 130,
	"./assets/images/gallery/neighbourhood/gallery_09.jpg": 131,
	"./assets/images/gallery/neighbourhood/gallery_09_thumb.jpg": 132,
	"./assets/images/home/amenities_panel.jpg": 329,
	"./assets/images/home/graphic_pattern.png": 530,
	"./assets/images/home/graphic_pattern.svg": 226,
	"./assets/images/home/hero_building_rendering.png": 330,
	"./assets/images/home/hero_entrance_rendering.jpg": 331,
	"./assets/images/home/interiors_panel.jpg": 332,
	"./assets/images/home/neighbourhood_panel.jpg": 333,
	"./assets/images/interiors/drag_icon.svg": 334,
	"./assets/images/interiors/drag_icon@2x.png": 531,
	"./assets/images/interiors/ensuite_dark.jpg": 335,
	"./assets/images/interiors/ensuite_light.jpg": 336,
	"./assets/images/interiors/hero.jpg": 337,
	"./assets/images/interiors/kitchen-living_dark.jpg": 338,
	"./assets/images/interiors/kitchen-living_light.jpg": 339,
	"./assets/images/neighbourhood/arrow-down-gold.svg": 532,
	"./assets/images/neighbourhood/arrow-down.svg": 533,
	"./assets/images/neighbourhood/base_map.png": 340,
	"./assets/images/neighbourhood/close_icon.png": 534,
	"./assets/images/neighbourhood/close_icon.svg": 535,
	"./assets/images/neighbourhood/hero.jpg": 341,
	"./assets/images/neighbourhood/mall.jpg": 342,
	"./assets/images/neighbourhood/plus_icon.png": 536,
	"./assets/images/neighbourhood/plus_icon.svg": 343,
	"./assets/images/neighbourhood/skytrain.jpg": 344,
	"./assets/images/popup/close_icon.svg": 537,
	"./assets/images/popup/popup_desktop.jpg": 538,
	"./assets/images/popup/popup_desktop.png": 539,
	"./assets/images/popup/popup_desktop.webp": 540,
	"./assets/images/popup/popup_mobile-tablet.jpg": 541,
	"./assets/images/popup/popup_mobile-tablet.png": 542,
	"./assets/images/popup/popup_mobile-tablet.webp": 543,
	"./assets/images/popup/riviera-desktop-popup@2x.webp": 265,
	"./assets/images/popup/riviera-mobile-popup.webp": 266,
	"./components/BookAppointment": 181,
	"./components/BookAppointment.js": 181,
	"./components/Button": 12,
	"./components/Button.js": 12,
	"./components/Counter": 345,
	"./components/Counter.js": 345,
	"./components/Footer/Footer": 183,
	"./components/Footer/Footer.js": 183,
	"./components/Footer/sections/Corporate": 185,
	"./components/Footer/sections/Corporate.js": 185,
	"./components/Footer/sections/Project": 184,
	"./components/Footer/sections/Project.js": 184,
	"./components/Gallery": 187,
	"./components/Gallery.js": 187,
	"./components/Header/Header": 178,
	"./components/Header/Header.js": 178,
	"./components/Header/elements/Menu": 180,
	"./components/Header/elements/Menu.js": 180,
	"./components/Header/elements/Nav": 179,
	"./components/Header/elements/Nav.js": 179,
	"./components/Icons/ArrowLeft": 31,
	"./components/Icons/ArrowLeft.js": 31,
	"./components/Icons/ArrowRight": 32,
	"./components/Icons/ArrowRight.js": 32,
	"./components/Intl": 182,
	"./components/Intl.js": 182,
	"./components/Layout/ContentBlock": 28,
	"./components/Layout/ContentBlock.js": 28,
	"./components/Layout/Hero": 33,
	"./components/Layout/Hero.js": 33,
	"./components/Layout/Title": 21,
	"./components/Layout/Title.js": 21,
	"./components/LoadingScreen": 177,
	"./components/LoadingScreen.js": 177,
	"./components/Popup": 186,
	"./components/Popup.js": 186,
	"./components/useIntl": 6,
	"./components/useIntl.js": 6,
	"./config/app.conf": 8,
	"./config/app.conf.js": 8,
	"./config/locales/en": 76,
	"./config/locales/en.js": 76,
	"./config/locales/ko": 149,
	"./config/locales/ko.js": 149,
	"./config/locales/tc": 150,
	"./config/locales/tc.js": 150,
	"./data/amenities": 34,
	"./data/amenities.js": 34,
	"./data/companies": 188,
	"./data/companies.js": 188,
	"./data/developer": 346,
	"./data/developer.js": 346,
	"./data/floorplans": 59,
	"./data/floorplans.js": 59,
	"./data/map": 347,
	"./data/map.js": 347,
	"./index": 74,
	"./index.js": 74,
	"./pages/Amenities/Amenities": 348,
	"./pages/Amenities/Amenities.js": 348,
	"./pages/Amenities/elements/Modal": 190,
	"./pages/Amenities/elements/Modal.js": 190,
	"./pages/Amenities/sections/Levels": 189,
	"./pages/Amenities/sections/Levels.js": 189,
	"./pages/Developer/Developer": 349,
	"./pages/Developer/Developer.js": 349,
	"./pages/Developer/elements/Slick": 192,
	"./pages/Developer/elements/Slick.js": 192,
	"./pages/Developer/sections/Companies": 193,
	"./pages/Developer/sections/Companies.js": 193,
	"./pages/Developer/sections/Hero": 191,
	"./pages/Developer/sections/Hero.js": 191,
	"./pages/Floorplans/Floorplans": 351,
	"./pages/Floorplans/Floorplans.js": 351,
	"./pages/Floorplans/elements/Compass": 196,
	"./pages/Floorplans/elements/Compass.js": 196,
	"./pages/Floorplans/elements/Table": 194,
	"./pages/Floorplans/elements/Table.js": 194,
	"./pages/Floorplans/sections/Views": 195,
	"./pages/Floorplans/sections/Views.js": 195,
	"./pages/Gallery/Gallery": 352,
	"./pages/Gallery/Gallery.js": 352,
	"./pages/Gallery/elements/Slick": 60,
	"./pages/Gallery/elements/Slick.js": 60,
	"./pages/Gallery/elements/Spotlight": 197,
	"./pages/Gallery/elements/Spotlight.js": 197,
	"./pages/Home/Home": 353,
	"./pages/Home/Home.js": 353,
	"./pages/Home/sections/Hero": 198,
	"./pages/Home/sections/Hero.js": 198,
	"./pages/Interiors/Interiors": 354,
	"./pages/Interiors/Interiors.js": 354,
	"./pages/Interiors/elements/OpalOnyx": 199,
	"./pages/Interiors/elements/OpalOnyx.js": 199,
	"./pages/Interiors/elements/OpalOnyxBlock": 69,
	"./pages/Interiors/elements/OpalOnyxBlock.js": 69,
	"./pages/Interiors/sections/Features": 200,
	"./pages/Interiors/sections/Features.js": 200,
	"./pages/Neighbourhood/Neighbourhood": 358,
	"./pages/Neighbourhood/Neighbourhood.js": 358,
	"./pages/Neighbourhood/elements/List": 203,
	"./pages/Neighbourhood/elements/List.js": 203,
	"./pages/Neighbourhood/elements/Map": 202,
	"./pages/Neighbourhood/elements/Map.js": 202,
	"./pages/Neighbourhood/sections/MapSection": 201,
	"./pages/Neighbourhood/sections/MapSection.js": 201,
	"./pages/NotFound": 359,
	"./pages/NotFound.js": 359,
	"./pages/Privacy": 360,
	"./pages/Privacy.js": 360,
	"./pages/Register/Register": 361,
	"./pages/Register/Register.js": 361,
	"./pages/Register/elements/Checkbox": 205,
	"./pages/Register/elements/Checkbox.js": 205,
	"./pages/Register/elements/Form": 204,
	"./pages/Register/elements/Form.js": 204,
	"./pages/Register/elements/Input": 35,
	"./pages/Register/elements/Input.js": 35,
	"./pages/Register/elements/Radio": 71,
	"./pages/Register/elements/Radio.js": 71,
	"./pages/Register/elements/Select": 70,
	"./pages/Register/elements/Select.js": 70,
	"./pages/ThankYou": 362,
	"./pages/ThankYou.js": 362,
	"./plugins/Analytics/Analytics": 171,
	"./plugins/Analytics/Analytics.js": 171,
	"./plugins/Analytics/elements/GTM": 173,
	"./plugins/Analytics/elements/GTM.js": 173,
	"./plugins/Analytics/elements/GTag": 172,
	"./plugins/Analytics/elements/GTag.js": 172,
	"./plugins/Analytics/elements/Hotjar": 174,
	"./plugins/Analytics/elements/Hotjar.js": 174,
	"./plugins/OnUpdate": 27,
	"./plugins/OnUpdate.js": 27,
	"./plugins/SEO": 170,
	"./plugins/SEO.js": 170,
	"./plugins/language": 168,
	"./plugins/language.js": 168,
	"./plugins/prerender": 176,
	"./plugins/prerender.js": 176,
	"./plugins/scrollTop": 169,
	"./plugins/scrollTop.js": 169,
	"./plugins/sitemap-generator": 363,
	"./plugins/sitemap-generator.js": 363,
	"./redux/counter": 36,
	"./redux/counter.js": 36,
	"./redux/intl": 56,
	"./redux/intl.js": 56,
	"./redux/load": 57,
	"./redux/load.js": 57,
	"./redux/reducers": 167,
	"./redux/reducers.js": 167,
	"./redux/store": 166,
	"./redux/store.js": 166,
	"./routes": 58,
	"./routes.js": 58,
	"./styles/fonts.css": 237,
	"./styles/global": 165,
	"./styles/global.js": 165,
	"./styles/media": 4,
	"./styles/media.js": 4,
	"./styles/theme": 7,
	"./styles/theme.js": 7,
	"./styles/utils": 1,
	"./styles/utils.js": 1
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 498;